import { Actions } from "@blue-chip/core";
import reduxAdapter from "@blue-chip/redux-adapter";
import store from "./store";

export const blueChipActions = Actions.config({
  adapter: reduxAdapter,
  mutator: store.dispatch,
});
